import { WebSocketTestPage } from './index'

import { RouteFactory } from './../../../shared/router/Route.factory'
import { RequiresAuthGuard, RequiresUsertypesGuard } from './../../../shared/router/guards'

export default [
  RouteFactory.create(
    WebSocketTestPage,
    '/diagnostics/websocket-test',
    [new RequiresAuthGuard(true), new RequiresUsertypesGuard(['system-admin'])],
    {
      name: 'WebSocket Diagnostics',
    }
  ),
]
